<template>
    <div class="form-container">
        <InputField
            :customErrorMessage="$t('form.fields.emailAddress.errorMessage')"
            :validationRules="validationRules"
            :label="$t('form.fields.emailAddress.label')"
            name="emailAddress"
            ref="emailAddress"
            type="email"
            icon="far fa-envelope"
        />
    </div>
</template>

<script>
export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'emailAddress',
            route: {
                relativeUrl: `email-address`,
                name: 'apply.emailAddress',
                meta: {
                    title: 'form.sections.aboutYou.emailAddress.heading',
                    tooltip: 'form.sections.aboutYou.emailAddress.tooltip',
                    tooltipType: 'small',
                    customTooltip: process.env.TERRITORY === 'usa',
                },
            },
            fields: {
                emailAddress: {
                    value: null,
                    mappedKey: 'email',
                    validationRules: {
                        required: true,
                        max: 100,
                        loqateEmail: true,
                    },
                },
            },
        }
    },

    mounted() {
        this.autoFocus(this.$refs.emailAddress)
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    computed: {
        validationRules: function () {
            return this.$store.getters.fieldValidationRules('emailAddress')
        },
    },
}
</script>
